const BOM= {
    window: window,
    document: window.document
};
//兼容ios 退出调用go_back
BOM.window.go_back=function () {}
export {
    BOM
};